import React, { useEffect } from 'react'
import styled from 'styled-components'

import breakpoints from '../../constants/breakpoints'
import { ImageType, Slide } from '../../types'
import { getNextSkipRoute } from '../../utils'

import LinkButton from '../LinkButton'
import Readspeaker from '../Readspeaker'

interface Props {
  title: string
  subtitle: string
  description: string
  image?: ImageType
  button: string
  nextLink?: string
  routes: Slide[]
  routeIndex?: string
  onSkipRoute: (path: string) => void
}

const Chapter: React.FC<Props> = ({
  title,
  subtitle,
  description,
  image,
  button,
  nextLink,
  routes,
  routeIndex,
  onSkipRoute,
}) => {
  useEffect(() => {
    const nextRoute = routeIndex && getNextSkipRoute(routeIndex, routes, true)
    nextRoute && onSkipRoute(nextRoute.path)
  }, [])

  return (
    <ChapterRows>
      <Content>
        <div>
          <Subtitle>{subtitle}</Subtitle>
          <h1 dangerouslySetInnerHTML={{ __html: title }}></h1>
          <Readspeaker align="left" />
          <Description dangerouslySetInnerHTML={{ __html: description }}></Description>
          {nextLink && (
            <Next>
              <LinkButton to={nextLink}>{button}</LinkButton>
            </Next>
          )}
        </div>
      </Content>
      {image && <Image src={image.src} />}
    </ChapterRows>
  )
}

const ChapterRows = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  width: 100%;
`

const Content = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: left;
  width: 100%;
  padding: 0 30px;
  align-items: center;

  @media (min-width: ${breakpoints.lg}) {
    flex: 0 0 50%;
    max-width: 50%;
  }

  & div {
    max-width: 550px;
    padding: 128px 0 128px 0;

    & div {
      padding: 0;
    }
  }
`

const Subtitle = styled.span`
  font-size: 1rem;
  font-weight: bold;
`

const Description = styled.p`
  margin: 0 0 35px;
`

const Next = styled.div`
  width: 225px;
`

const Image = styled.div<{ src: string }>`
  align-items: center;
  background-image: url(${({ src }) => src});
  background-position: center center;
  background-size: cover;
  display: none;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  width: 100%;
  flex: 0 0 50%;
  max-width: 50%;

  @media (min-width: ${breakpoints.lg}) {
    display: flex;
  }
`

export default Chapter
